export const LibraryModel = {
  ru: {
    lineup: 'Оборудование',
    headerText2: 'Jenbacher. Модельный ряд 2-ой серии',
    headerText3: 'Jenbacher. Модельный ряд 3-ой серии',
    headerText4: 'Jenbacher. Модельный ряд 4-ой серии',
    headerText6: 'Jenbacher. Модельный ряд 6-ой серии',
    headerTextdiane: 'Jenbacher. Система автоматики DIA.NE',
    headerTextbroadxii: 'BROAD. Абсорбционные чиллеры, XII поколение',

    dianeText:
      'Система выступает человеко-машинным интерфейсом при вводе в эксплуатацию, эксплуатации, техобслуживании и диагностике неисправностей газовых двигателей. Таким образом, можно в любой момент предпринять действия, необходимые для управления газовыми двигателями, – локально или дистанционно. Многозадачная операционная система реального времени обеспечивает выполнение критических по времени и важных для безопасности задач по регулировке и контролю двигателей, а также управлению двигателями. Операционная система Windows «Windows® 7 embedded» от Microsoft является подходящей платформой для визуализации и регистрации данных. В сочетании с инструментом для управления установками в онлайн-режиме myPlant™ от INNIO возможно надежное дистанционное управление установкой через Интернет.',

    ThirdBlock1: 'Вид топлива',
    ThirdBlock2: 'Тип двигателя',
    ThirdBlock3: 'Электрическая мощность',
    ThirdBlock4: 'Тепловая мощность',
    ThirdBlock5: 'Ввод в эксплуатацию',

    FourBlock: 'Просмотреть / скачать технические данные',
  },

  md: {
    lineup: 'Echipament',
    headerText2: 'Jenbacher. Gama de modele Seria 2',
    headerText3: 'Jenbacher. Gama de modele Seria 3',
    headerText4: 'Jenbacher. Gama de modele Seria 4',
    headerText6: 'Jenbacher. Gama de modele Seria 6',
    headerTextdiane: 'Jenbacher. Sistem de automatizare DIA.NE',
    headerTextbroadxii: 'BROAD. Chillere cu absorbție, generația XII',

    dianeText:
      'Sistemul acționează ca o interfață om-mașină la punerea în funcțiune, operarea, întreținerea și diagnosticarea defectelor motoarelor cu gaz. Astfel, este posibil, în orice moment, să se ia măsurile necesare pentru a controla motoarele cu gaz — local sau de la distanță. Sistemul de operare multitasking în timp real îndeplinește sarcinile critice și importante pentru siguranța reglării, monitorizării și controlului motoarelor. Sistemul de operare Microsoft Windows® 7 Embedded este o platformă potrivită pentru vizualizarea și înregistrarea datelor. Împreună cu instrumentul online de gestionare a instalațiilor myPlant™ de la INNIO, acesta permite controlul fiabil al instalației de la distanță prin internet.',

    ThirdBlock1: 'Combustibil',
    ThirdBlock2: 'Tip motor',
    ThirdBlock3: 'Putere electrică',
    ThirdBlock4: 'Putere termică',
    ThirdBlock5: 'Punere în funcțiune',

    FourBlock: 'Vizualizați / descărcați datele tehnice',
  },

  en: {
    lineup: 'Equipment',
    headerText2: 'Jenbacher. Type 2 Gas Engines',
    headerText3: 'Jenbacher. Type 3 Gas Engines',
    headerText4: 'Jenbacher. Type 4 Gas Engines',
    headerText6: 'Jenbacher. Type 6 Gas Engines',
    headerTextdiane: 'Jenbacher. Engine Management Systems DIA.NE',
    headerTextbroadxii: 'BROAD. Absorption chillers, XII generation',

    dianeText:
      'The system provides the human-machine interface for commissioning, operation, maintenance, and troubleshooting of the gas engines. This keeps the Jenbacher gas engine under control at all times—directly on site or through a remote connection. A real-time multitasking operating system handles time-critical and safety-relevant engine regulation, monitoring, and control tasks. Microsoft Windows® 7 Embedded provides the platform for visualization and data recording. Combined with the INNIO myPlant™ online plant management tool, it enables reliable remote control of the plant over the internet.',

    ThirdBlock1: 'Fuel',
    ThirdBlock2: 'Engine type',
    ThirdBlock3: 'Electrical output',
    ThirdBlock4: 'Thermal output',
    ThirdBlock5: 'Commissioning',

    FourBlock: 'Preview / download technical details',
  },
};
